import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Footer } from "./components/Footer";
import { Navbar } from "./components/Navbar";
import { logoPath } from "./data/site";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Pricing from "./pages/Pricing";
import Products from "./pages/Products";
import Services from "./pages/Services";

export default function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = window.setTimeout(() => setLoading(false), 900);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-ink text-white">
      {loading && (
        <div className="fixed inset-0 z-[100] grid place-items-center bg-ink">
          <div className="relative grid place-items-center">
            <div className="absolute h-28 w-28 animate-ping rounded-[2rem] bg-electric/20" />
            <img
              src={logoPath}
              alt="Lazerwebs loading logo"
              className="relative h-20 w-20 rounded-[1.4rem] object-cover shadow-glow"
            />
          </div>
        </div>
      )}
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}
